import { BoxProps, FlexProps } from '@chakra-ui/react'

export const overflowBody: { boxProps: BoxProps; footerFlexProps: FlexProps } = {
  boxProps: {
    flex: 1,
    minH: 0,
    overflowY: 'auto',
  },
  footerFlexProps: {
    pt: 1,
    bg: 'gray.100',
  },
}
